import { toast } from "react-toastify";

export type PublishOptions = {
    notify?: boolean;
};

export function showPublishResultToast(succeeded: boolean): void {
    if (succeeded) {
        toast.success("Erfolgreich veröffentlicht!");
        return;
    }

    toast.error("Oops, etwas ist schief gegangen. Veröffentlichung fehlgeschlagen ...");
}
